var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUninstallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7422 18.2822H3.86719C3.76406 18.2822 3.67969 18.3666 3.67969 18.4697V19.876C3.67969 19.9791 3.76406 20.0635 3.86719 20.0635H20.7422C20.8453 20.0635 20.9297 19.9791 20.9297 19.876V18.4697C20.9297 18.3666 20.8453 18.2822 20.7422 18.2822Z",
    fill: "#7C7B7B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8928 12.0533L14.6249 12.0533C14.7819 12.0533 14.8686 12.2337 14.7725 12.3579L12.1475 15.679C12.13 15.7014 12.1076 15.7196 12.082 15.732C12.0564 15.7445 12.0283 15.751 11.9999 15.751C11.9714 15.751 11.9433 15.7445 11.9177 15.732C11.8922 15.7196 11.8697 15.7014 11.8522 15.679L9.22721 12.3556C9.13112 12.2337 9.21783 12.0533 9.37487 12.0533L11.1116 12.0533L11.1116 4.12435C11.1116 4.02122 11.196 3.93685 11.2991 3.93685L12.7053 3.93685C12.8085 3.93685 12.8928 4.02122 12.8928 4.12435L12.8928 12.0533Z",
    fill: "#7C7B7B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUninstallIcon);
export default __webpack_public_path__ + "static/media/uninstall-icon.95863d5e7c3ea40b5f3f713b18f15930.svg";
export { ForwardRef as ReactComponent };